import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ApplicationType } from '../domain/auth/enums/auth.enums';

@Injectable({
    providedIn: 'root',
})
export class DeviceService {
    public isMobile;
    public isTablet;
    public isDesktop;
    public isPWA;
    public isDesktopOrTablet;
    public deviceInfo;
    public browser;
    public orientation;
    public os;
    public appTypeId;
    constructor(private deviceService: DeviceDetectorService) {
        this.initService();
    }

    initService(): void {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.isDesktop = this.deviceService.isDesktop();
        this.isDesktopOrTablet = this.isDesktop || this.isTablet;
        this.deviceInfo = `${this.deviceService.getDeviceInfo().deviceType} | ${this.deviceService.getDeviceInfo().os}(${
            this.deviceService.getDeviceInfo().os_version
        }) | ${this.deviceService.getDeviceInfo().browser}(${this.deviceService.getDeviceInfo().browser_version})`;
        this.browser = this.deviceService.browser;
        this.orientation = this.deviceService.orientation;
        this.os = this.deviceService.os;
        this.isPWA = this.isPwa();
        this.appTypeId = this.isMobile ? ApplicationType.AngularMobile : ApplicationType.AngularDesktop;
    }

    isPwa(): boolean {
        const displayModes = ['fullscreen', 'standalone', 'minimal-ui'];
        return (
            displayModes.some((displayMode) => window.matchMedia(`(display-mode: '${displayMode}')`).matches) ||
            document.referrer.includes('android-app://')
        );
    }
}
